module.exports = __webpack_public_path__ + "img/weatherbg.16ea0fad.jpg";